import React, { useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { notify } from "../../../utils/http";

// Función auxiliar para obtener el token (mismo código que en http.jsx)
function getToken() {
  return (
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("access_token") ||
    sessionStorage.getItem("token")
  );
}

export default function EliminarContrato({
  registro = {},
  onClose = () => {},
  onDeleted = () => {},
}) {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const id = registro.id;
      if (!id) throw new Error("ID de contrato no encontrado.");

      const url = apiRoutes.contratos.eliminarUrl(id);
      const token = getToken();

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      // Leer el cuerpo de la respuesta (puede ser JSON o texto)
      const text = await response.text();
      let data = null;
      try {
        data = JSON.parse(text);
      } catch (e) {
        // No es JSON, data queda null, text contiene el cuerpo plano
      }

      if (!response.ok) {
        const errorMsg =
          data?.error ||
          data?.error_description ||
          data?.message ||
          data?.detail ||
          data?.title ||
          text ||
          `Error ${response.status}`;
        throw new Error(errorMsg);
      }

      // Éxito
      notify({ type: "success", message: "Contrato eliminado correctamente" });
      onDeleted();
      onClose();
    } catch (e) {
      console.error("Error al eliminar el contrato:", e);
      const msg = e.message || "Error al eliminar el contrato.";
      notify({ type: "error", message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Eliminar Contrato</h2>
      </div>

      <div className="px-6 pt-4">
        <div className="mb-4 px-4 py-3 text-sm text-blue-600">
          ¿Está seguro que desea eliminar este contrato?
        </div>

        {/* Resumen de datos a eliminar */}
        <div className="bg-gray-50 px-6 py-6 mb-2 space-y-2">
          <div>
            <span className="text-gray-500 mr-1">Código:</span>
            <span className="font-medium">{registro.codigo ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Descripción:</span>
            <span className="font-medium">{registro.descricaoTexto ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Fecha Contrato:</span>
            <span className="font-medium">{registro.data ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Fecha Inicio:</span>
            <span className="font-medium">{registro.dataFechaini ?? "—"}</span>
          </div>
          <div>
            <span className="text-gray-500 mr-1">Fecha Fin:</span>
            <span className="font-medium">{registro.dataFechafin ?? "—"}</span>
          </div>
        </div>
      </div>

      <div className="px-6 py-4 border-t flex gap-2 modal-footer">
        <button className="btn-fil" onClick={handleDelete} disabled={loading}>
          {loading ? "Eliminando…" : "Eliminar"}
        </button>
        <button className="btn-fil" onClick={onClose}>
          Cancelar
        </button>
      </div>
    </div>
  );
}